import React from 'react';
import {FormattedHTMLMessage, useIntl} from 'react-intl';
import classnames from 'classnames';
import {getMessageValue} from '../i18n/messageUtil.mjs';
import {parseAnswerValue} from '../util/questionUtil.jsx';
import PropTypes from 'prop-types';
import {useText} from './TextContext';

const AnswersList = ({answers, className, filter, renderAnswer}) => {
  const intl = useIntl();
  const cssBem = 'answersList';
  const textContext = useText();
  const classes = classnames(className, cssBem);
  const answersToFilter = filter || ['guideStartTime', 'guideEndTime', 'guideStarted'];

  const filterHiddenAndNullAnswers = ({appkey, view, value}) => {
    const hasValue = value !== null;
    const isHidden = view && view.attributes && view.attributes.hidden;
    const isSystemAppKey = answersToFilter.includes(appkey) || !view;
    return hasValue && !isHidden && !isSystemAppKey;
  };

  const renderAnswers = () => {
    const cssBEM = 'answer';

    const filteredAnswers = Object.entries(answers)
      /* eslint-disable-next-line no-unused-vars */
      .filter(([key, answer]) => filterHiddenAndNullAnswers(answer));

    /* eslint-disable-next-line no-unused-vars */
    const sortedAnswers = filteredAnswers.sort(([_, a], [_2, b]) => {
      return a.timestamp - b.timestamp;
    });

    return sortedAnswers.map(([key, answer]) => {
      return renderAnswer ? (
        renderAnswers(key, answer)
      ) : (
        <div className={cssBEM} key={`${key}_${answer}`}>
          <h4 className={`${cssBEM}__key`}>
            {textContext?.[`details.${answer.appkey}`] || (
              <FormattedHTMLMessage
                id={
                  getMessageValue(intl.locale, `details.${answer.appkey}`) ? `details.${answer.appkey}` : answer.appkey
                }
              />
            )}
          </h4>
          <div className={`${cssBEM}__value`}>{parseAnswerValue(intl, answer, true)}</div>
        </div>
      );
    });
  };

  return <div className={classes}>{renderAnswers()}</div>;
};

AnswersList.propTypes = {
  answers: PropTypes.object.isRequired,
  className: PropTypes.string,
  filter: PropTypes.array,
  renderAnswer: PropTypes.func,
};

export default AnswersList;
